<template>
  <div class="">
    Select an option
  </div>
</template>

<script>

export default {
    name: 'settings'
};
</script>

<style lang="scss" scoped>
</style>
